export default __webpack_public_path__ + "static/media/mediagal_pos3.a8fa3dff.jpg";